import { WEB_COMPONENT_SENSOR_ATLASSIAN_JIRA_CONFLUENCE } from '../../../../webcomponents.constants';
import { AtlassianJiraConfluenceComponent } from './component/AtlassianJiraConfluenceComponent';

export { AtlassianJiraConfluenceComponent };
window.customElements.define(WEB_COMPONENT_SENSOR_ATLASSIAN_JIRA_CONFLUENCE, AtlassianJiraConfluenceComponent);
